import { NodeConfig } from '../types';

export const injectNodeTheme = (config: NodeConfig, colorMode: 'light' | 'dark' | null = null) => {
  const root = document.documentElement;
  
  let primary = config.primaryColor ?? '#0F1F3D';
  const secondary = config.secondaryColor ?? '#1A56A0';

  // If the primary color is one of the default dark navy/slate colors, and we are in dark mode,
  // swap it to a brighter blue (Blue 500) so that text, backgrounds, and borders remain visible.
  const isDark = colorMode === 'dark' || root.getAttribute('data-theme') === 'dark';
  const isDarkDefault = !config.primaryColor || ['#0f172a', '#1e293b', '#0f1f3d', '#0b3d91'].includes(config.primaryColor.toLowerCase());
  
  if (isDarkDefault && isDark) {
    primary = '#3b82f6'; // Blue 500 (lighter blue for dark mode visibility)
  }

  root.style.setProperty('--node-primary', primary);
  root.style.setProperty('--node-secondary', secondary);
  root.style.setProperty('--color-brand-primary', primary);
  root.style.setProperty('--color-brand-secondary', secondary);
  
  root.style.removeProperty('--color-brand-text'); // Clean up previous decoupled fix

  root.style.setProperty('--node-logo', config.logoUrl ? `url(${config.logoUrl})` : 'none');
  
  // Dynamic Fonts
  const fonts: Record<string, string> = {
    sans: '"DM Sans Variable", ui-sans-serif, system-ui, sans-serif',
    display: '"DM Serif Display", serif',
    mono: 'ui-monospace, SFMono-Regular, monospace',
    serif: 'ui-serif, Georgia, Cambria, "Times New Roman", Times, serif'
  };
  root.style.setProperty('--font-main', fonts[config.fontFamily || 'sans'] || fonts.sans);
  
  // Dynamic Corners
  const radius: Record<string, string> = {
    none: '0px',
    sm: '0.125rem',
    md: '0.375rem',
    lg: '1rem',
    full: '9999px'
  };
  root.style.setProperty('--node-radius', radius[config.roundedCorners || 'lg'] || radius.lg);

  // Set theme data attributes for global CSS targeting
  if (config.themeId) {
    root.setAttribute('data-style', config.themeId);
  }
  if (colorMode) {
    root.setAttribute('data-theme', colorMode);
  }
};
